import * as z from 'zod/mini';

export const devSettingsSchema = z.object({
  apiBaseUrlOrigin: z.string(),
  apiBaseUrlPath: z.string(),
  environmentId: z.string(),
  extensions: z.object({
    aptos: z.boolean(),
    bitcoin: z.boolean(),
    evm: z.boolean(),
    phantomRedirectSolana: z.boolean(),
    solana: z.boolean(),
    starknet: z.boolean(),
    sui: z.boolean(),
    tron: z.boolean(),
    walletConnectEvm: z.boolean(),
    walletConnectSolana: z.boolean(),
    zerodev: z.boolean(),
  }),
});
